import React, { Suspense } from 'react';
import { Navigate, Routes as ReactRouterRoutes, Route } from 'react-router-dom';

import { retryImportChunk } from '@savgroup-front-common/core/helpers/retryImportChunk';
import { BaseLoader } from '@savgroup-front-common/core/molecules/BaseLoader';

import { ROUTES } from './routing';

const InterventionDetail = React.lazy(() =>
  retryImportChunk(
    () => import('../pages/InterventionDetail/InterventionDetail'),
  ),
);

const InterventionSpareParts = React.lazy(() =>
  retryImportChunk(
    () => import('../pages/InterventionSpareParts/InterventionSpareParts'),
  ),
);

const CreateQuotation = React.lazy(() =>
  retryImportChunk(() => import('../pages/CreateQuotation/CreateQuotation')),
);

const QuotationDetail = React.lazy(() =>
  retryImportChunk(() => import('../pages/QuotationDetail/QuotationDetail')),
);

const Interventions = React.lazy(() =>
  retryImportChunk(() => import('../pages/Interventions/Interventions')),
);

const FinishIntervention = React.lazy(() =>
  retryImportChunk(
    () => import('../pages/FinishIntervention/FinishIntervention'),
  ),
);

const AddImage = React.lazy(() =>
  retryImportChunk(() => import('../pages/AddImage/AddImage')),
);

const AddImageByDocumentType = React.lazy(() =>
  retryImportChunk(
    () =>
      import('../pages/AddImage/AddImageByDocumentType/AddImageByDocumentType'),
  ),
);

const Routes = () => {
  return (
    <Suspense fallback={<BaseLoader />}>
      <ReactRouterRoutes>
        <Route
          path=""
          element={<Navigate to={ROUTES.INTERVENTIONS_LIST} replace />}
        />
        <Route path={ROUTES.INTERVENTIONS_LIST} element={<Interventions />} />
        <Route
          path={`${ROUTES.INTERVENTION_DETAIL}`}
          element={<InterventionDetail />}
        />
        <Route
          path={`${ROUTES.INTERVENTION_SPARE_PARTS}`}
          element={<InterventionSpareParts />}
        />
        <Route
          path={`${ROUTES.CREATE_QUOTATION}`}
          element={<CreateQuotation />}
        />
        <Route
          path={`${ROUTES.QUOTATION_DETAIL}`}
          element={<QuotationDetail />}
        />
        <Route
          path={`${ROUTES.FINISH_INTERVENTION}`}
          element={<FinishIntervention />}
        />
        <Route path={`${ROUTES.ADD_IMAGE}`} element={<AddImage />} />
        <Route
          path={`${ROUTES.ADD_DOCUMENT_TYPE_IMAGE}`}
          element={<AddImageByDocumentType />}
        />
        <Route
          path={`${ROUTES.CUSTOMER_ABSENT}`}
          element={<AddImageByDocumentType isCustomerAbsentFlow />}
        />
      </ReactRouterRoutes>
    </Suspense>
  );
};

export default Routes;
